/* HEY MI AMOR — Refonte 2026 : interactions et animations.
   Tout est progressif : sans JS, le site reste complet et lisible. */
(function () {
  'use strict';
  var doc = document;
  var body = doc.body;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var raf = window.requestAnimationFrame.bind(window);
  var SIZE_RE = /^(size|taille|größe|grösse|talla|taglia|tamaño)$/i;

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  /* ---------- 1. Bandeau d'annonce en marquee ---------- */
  function buildMarquee() {
    var bar = $('.utility-bar');
    if (!bar || bar.dataset.hmaMarquee) return;
    var messages = $$('.announcement-bar__message', bar).map(function (el) {
      var link = el.closest('a');
      return { text: el.textContent.replace(/\s+/g, ' ').trim(), href: link ? link.getAttribute('href') : null };
    }).filter(function (m) { return m.text; });
    if (!messages.length) return;
    var unit = [];
    while (unit.length < 10) unit = unit.concat(messages);
    var track = doc.createElement('div');
    track.className = 'hma-marquee__track';
    unit.concat(unit).forEach(function (m, i) {
      var item = doc.createElement(m.href ? 'a' : 'span');
      item.className = 'hma-marquee__item';
      item.textContent = m.text;
      if (m.href) item.href = m.href;
      if (i >= unit.length) item.setAttribute('aria-hidden', 'true');
      track.appendChild(item);
    });
    var wrap = doc.createElement('div');
    wrap.className = 'hma-marquee';
    wrap.appendChild(track);
    var grid = $('.utility-bar__grid', bar);
    if (grid) grid.style.display = 'none';
    bar.appendChild(wrap);
    bar.dataset.hmaMarquee = '1';
  }

  /* ---------- 2. En-tête : transparent sur le héro, masqué en descendant ---------- */
  function setupHeader() {
    var header = $('.section-header');
    if (!header) return;
    var hero = $('#MainContent > .shopify-section:first-child .slideshow, #MainContent > .shopify-section:first-child .banner');
    var overlay = body.classList.contains('template-index') && !!hero;
    if (overlay) body.classList.add('hma-overlay');

    function measure() {
      var h = header.getBoundingClientRect().height;
      doc.documentElement.style.setProperty('--hma-header-offset', Math.round(h) + 'px');
    }
    measure();
    window.addEventListener('resize', measure, { passive: true });

    var lastY = window.scrollY;
    var ticking = false;
    function update() {
      var y = window.scrollY;
      var heroBottom = overlay && hero ? hero.getBoundingClientRect().bottom : 0;
      header.classList.toggle('hma-solid', !overlay || heroBottom <= header.offsetHeight + 1 || header.matches(':hover') || body.classList.contains('overflow-hidden-tablet') || !!$('.header__submenu[open], details[open] > .header__submenu, .menu-opening', header));
      var goingDown = y > lastY + 4;
      var goingUp = y < lastY - 4;
      if (y < 120) body.classList.remove('hma-header-hidden');
      else if (goingDown && !header.contains(doc.activeElement)) body.classList.add('hma-header-hidden');
      else if (goingUp) body.classList.remove('hma-header-hidden');
      lastY = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { raf(update); ticking = true; }
    }, { passive: true });
    header.addEventListener('mouseenter', update);
    header.addEventListener('mouseleave', update);
    header.addEventListener('toggle', update, true);
    update();
  }

  /* ---------- 3. Titres du héro : mot à mot + accent manuscrit ---------- */
  function splitWords(el, scriptIndex) {
    if (!el || el.dataset.hmaSplit) return;
    var words = el.textContent.replace(/\s+/g, ' ').trim().split(' ');
    if (!words[0]) return;
    el.setAttribute('aria-label', words.join(' '));
    el.textContent = '';
    words.forEach(function (w, i) {
      var outer = doc.createElement('span');
      outer.className = 'hma-word';
      outer.setAttribute('aria-hidden', 'true');
      var inner = doc.createElement('span');
      inner.textContent = w;
      if (i === scriptIndex) inner.className = 'hma-script';
      inner.style.setProperty('--i', i);
      outer.appendChild(inner);
      el.appendChild(outer);
      if (i < words.length - 1) el.appendChild(doc.createTextNode(' '));
    });
    el.dataset.hmaSplit = '1';
  }
  function setupHero() {
    $$('.slideshow .banner__heading').forEach(function (h) {
      var n = h.textContent.trim().split(/\s+/).length;
      // le dernier mot passe en écriture manuscrite, comme une signature
      splitWords(h, n > 1 ? n - 1 : -1);
    });
    $$('.slideshow .banner__text, .slideshow .banner__buttons').forEach(function (el, i) {
      el.classList.add('hma-fade-up');
      el.style.setProperty('--d', (0.45 + i * 0.08) + 's');
    });
    raf(function () { raf(function () { body.classList.add('hma-ready'); }); });
    // fin d'animation : on fige l'état final (évite tout défaut de rendu du navigateur)
    $$('.hma-word').forEach(function (w) {
      var s = w.firstElementChild;
      if (!s) return;
      var done = function () { w.classList.add('is-done'); };
      s.addEventListener('animationend', done, { once: true });
      setTimeout(done, 2400);
    });
  }

  /* ---------- 4. Bannières empilées (desktop) ---------- */
  function setupStack() { /* retiré : le défilement reste unifié */ }

  /* ---------- 5. Libellé panier « PANIER (n) » ---------- */
  function setupCartLabel() {
    var link = $('#cart-icon-bubble');
    if (!link) return;
    var label = $('.hma-cart-label', link);
    if (!label) return;
    var last = label.textContent;
    new MutationObserver(function () {
      var l = $('.hma-cart-label', link);
      if (l && l.textContent !== last) {
        last = l.textContent;
        l.classList.remove('is-bump'); void l.offsetWidth; l.classList.add('is-bump');
      }
    }).observe(link, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- 6. Fiche produit : stock, grammage, barre d'achat collante ---------- */
  function setupProduct() {
    var info = $('.product__info-container');
    if (!info) return;
    var form = $('product-form form[action*="/cart/add"]', info) || $('product-form form');
    var submit = $('product-form [name="add"]', info) || $('product-form [name="add"]');

    // grammage détecté dans la description (ex. « 280 g/m² ») → cellule qualité
    var desc = $('.product__description', info);
    var gsmCell = $('[data-hma-gsm]', info);
    if (desc && gsmCell) {
      var m = desc.textContent.match(/(\d{3})\s?(?:g\/m²|g\/m2|gsm)/i);
      if (m) { $('b', gsmCell).textContent = m[1] + ' g/m²'; gsmCell.hidden = false; }
    }


    // galerie courte : elle reste visible pendant qu'on lit la colonne d'achat
    var mediaWrap = $('.product__media-wrapper');
    var infoWrap = $('.product__info-wrapper');
    function stickMedia() {
      if (!mediaWrap || !infoWrap) return;
      var shorter = window.innerWidth >= 990 && mediaWrap.offsetHeight + 40 < infoWrap.offsetHeight && mediaWrap.offsetHeight < window.innerHeight * 1.1;
      mediaWrap.classList.toggle('hma-media-sticky', shorter);
    }
    stickMedia();
    window.addEventListener('load', stickMedia);
    window.addEventListener('resize', stickMedia, { passive: true });


    // lien « Guide des tailles » à côté du libellé de taille
    var tpl = $('#hma-size-guide-tpl');
    if (tpl) {
      var placeGuide = function () {
        if ($('.hma-size-guide', info)) return;
        var legend = $$('variant-selects fieldset legend, variant-selects .form__label', info).filter(function (l) { return SIZE_RE.test(l.textContent.replace(/[:\s]+$/,'').trim().split(/\s+/).pop()) || /size|taille|größe|talla|taglia/i.test(l.textContent); })[0];
        if (legend) legend.appendChild(tpl.content.cloneNode(true));
      };
      placeGuide();
      new MutationObserver(placeGuide).observe(info, { childList: true, subtree: true });
    }

    // disponibilité en direct
    var stock = $('.hma-stock', info);
    function syncStock() {
      if (!stock || !submit) return;
      var out = submit.disabled;
      stock.classList.toggle('is-out', out);
      stock.textContent = out ? stock.dataset.out : stock.dataset.in;
    }
    if (submit) new MutationObserver(syncStock).observe(submit, { attributes: true, attributeFilter: ['disabled'] });
    syncStock();

    // barre collante
    if (!submit) return;
    var bar = $('.hma-sticky-atc');
    if (!bar) return;
    var barBtn = $('.button', bar);
    var priceSrc = $('.price-item--last, .price__regular .price-item--regular', info);
    var barPrice = $('[data-hma-price]', bar);
    var barVariant = $('[data-hma-variant]', bar);
    function syncBar() {
      if (priceSrc && barPrice) barPrice.textContent = ($('.price .price-item--sale', info) || $('.price-item--last', info) || priceSrc).textContent.trim();
      if (barVariant) {
        var checked = $$('variant-selects input[type="radio"]:checked').map(function (r) { return r.value; });
        var sel = $$('variant-selects select').map(function (s) { return s.value; });
        barVariant.textContent = (checked.length ? checked : sel).join(' · ');
      }
      barBtn.disabled = submit.disabled;
      barBtn.textContent = (submit.querySelector('span') || submit).textContent.trim();
    }
    barBtn.addEventListener('click', function () {
      if (submit.disabled) return;
      submit.click();
    });
    new MutationObserver(syncBar).observe(info, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'checked'] });
    doc.addEventListener('change', function (e) { if (e.target.closest('variant-selects')) setTimeout(syncBar, 60); });
    syncBar();
    // visible dès que le vrai bouton est passé au-dessus de l'écran, masquée à l'approche du pied de page
    var footerEl = $('.footer');
    function toggleBar() {
      var passed = submit.getBoundingClientRect().bottom < 0;
      var nearFooter = footerEl ? footerEl.getBoundingClientRect().top < window.innerHeight : false;
      var show = passed && !nearFooter;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      barBtn.tabIndex = show ? 0 : -1;
    }
    window.addEventListener('scroll', toggleBar, { passive: true });
    window.addEventListener('resize', toggleBar, { passive: true });
    toggleBar();
  }


  /* ---------- 6b. Description produit → accordéons par intertitre ---------- */
  function setupDescription() {
    $$('.product__description').forEach(function (d) {
      if (d.dataset.hmaDesc) return;
      var heads = $$(':scope > h2, :scope > h3', d);
      if (!heads.length) return;
      var frag = doc.createDocumentFragment();
      var intro = doc.createElement('div');
      intro.className = 'hma-desc__intro';
      var node = d.firstChild;
      while (node && node !== heads[0]) { var next = node.nextSibling; intro.appendChild(node); node = next; }
      if (intro.textContent.trim()) frag.appendChild(intro);
      heads.forEach(function (h, i) {
        var det = doc.createElement('details');
        if (i === 0) det.open = true;
        var sum = doc.createElement('summary');
        sum.textContent = h.textContent.trim();
        var bodyEl = doc.createElement('div');
        bodyEl.className = 'hma-desc__body';
        var n = h.nextSibling;
        while (n && heads.indexOf(n) === -1) { var nx = n.nextSibling; bodyEl.appendChild(n); n = nx; }
        h.remove();
        det.appendChild(sum); det.appendChild(bodyEl);
        frag.appendChild(det);
      });
      d.innerHTML = '';
      d.appendChild(frag);
      d.classList.add('hma-desc');
      d.dataset.hmaDesc = '1';
    });
  }


  /* ---------- 6c. Tiroir panier : « ajoute une 2e pièce » avec choix de taille ---------- */
  var upsellCache = {};
  function money(cents, currency) {
    try { return new Intl.NumberFormat(doc.documentElement.lang || 'fr', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + (currency || ''); }
  }
  function fillUpsell() {
    var box = $('cart-drawer .hma-upsell');
    if (!box || box.dataset.filled) return;
    box.dataset.filled = '1';
    var pid = box.dataset.productId;
    var exclude = (box.dataset.exclude || '').split(',');
    if (!pid) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url = root + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=related';
    var p = upsellCache[url] || (upsellCache[url] = fetch(url).then(function (r) { return r.json(); }));
    p.then(function (data) {
      var products = (data.products || []).filter(function (pr) { return pr.available && exclude.indexOf(String(pr.id)) === -1; }).slice(0, 3);
      if (!products.length || !box.isConnected) return;
      var count = parseInt(box.dataset.count, 10) || 0;
      var title = doc.createElement('p');
      title.className = 'hma-upsell__title';
      title.textContent = count === 1 ? box.dataset.titleShip : box.dataset.titleAny;
      var list = doc.createElement('div');
      list.className = 'hma-upsell__list';
      products.forEach(function (pr, i) {
        var sizeIdx = -1;
        (pr.options || []).forEach(function (o, k) { var n = typeof o === 'string' ? o : o.name; if (SIZE_RE.test(n)) sizeIdx = k; });
        var item = doc.createElement('div');
        item.className = 'hma-upsell__item';
        item.style.setProperty('--i', i);
        var img = pr.featured_image ? pr.featured_image + (pr.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '';
        item.innerHTML = '<a class="hma-upsell__media" href="' + pr.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="300" height="375">' : '') + '</a>' +
          '<a class="hma-upsell__name" href="' + pr.url + '"></a><span class="hma-upsell__price"></span><div class="hma-upsell__sizes"></div>';
        $('.hma-upsell__name', item).textContent = pr.title;
        $('.hma-upsell__price', item).textContent = money(pr.price, box.dataset.currency);
        var sizes = $('.hma-upsell__sizes', item);
        var seen = {};
        (pr.variants || []).forEach(function (v) {
          var label = sizeIdx > -1 ? v['option' + (sizeIdx + 1)] : v.title;
          if (seen[label]) { if (v.available && seen[label].disabled) { seen[label].disabled = false; seen[label].dataset.variant = v.id; } return; }
          var b = doc.createElement('button');
          b.type = 'button'; b.className = 'hma-upsell__size'; b.textContent = label; b.dataset.variant = v.id; b.disabled = !v.available;
          seen[label] = b; sizes.appendChild(b);
        });
        list.appendChild(item);
      });
      box.appendChild(title);
      box.appendChild(list);
    }).catch(function () {});
  }
  function upsellAdd(btn) {
    var drawer = $('cart-drawer');
    btn.classList.add('is-loading');
    $$('.hma-upsell__size').forEach(function (b) { b.disabled = true; });
    var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble'];
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }], sections: sections, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) throw res;
      if (drawer && drawer.renderContents) {
        res.id = Number(btn.dataset.variant);
        drawer.renderContents(res);
      } else { window.location.href = root + 'cart'; }
    }).catch(function () { window.location.href = root + 'cart'; });
  }
  function setupUpsell() {
    var drawer = $('cart-drawer');
    if (!drawer) return;
    new MutationObserver(function () { fillUpsell(); }).observe(drawer, { childList: true, subtree: true });
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('.hma-upsell__size');
      if (b && !b.disabled) upsellAdd(b);
    });
    fillUpsell();
  }


  /* ---------- 10. Espacement de la colonne d'achat : seulement entre blocs visibles ---------- */
  function setupInfoSpacing() {
    var info = $('.product__info-container');
    if (!info) return;
    var pending = false;
    function apply() {
      pending = false;
      var first = true;
      Array.prototype.forEach.call(info.children, function (c) {
        var visible = c.offsetHeight > 0 && getComputedStyle(c).display !== 'none';
        c.classList.toggle('hma-gap', visible && !first);
        if (visible) first = false;
      });
    }
    apply();
    new MutationObserver(function () { if (!pending) { pending = true; raf(apply); } }).observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    window.addEventListener('load', apply);
  }

  /* ---------- 11. Pop-up club ---------- */
  function setupPopup() {
    var pop = $('[data-hma-pop]');
    if (!pop) return;
    var KEY = 'hma_pop_until';
    function store(days) { try { localStorage.setItem(KEY, String(Date.now() + days * 864e5)); } catch (e) {} }
    function blocked() { try { return Date.now() < Number(localStorage.getItem(KEY) || 0); } catch (e) { return false; } }
    function open() {
      if (pop.classList.contains('is-open') || $('cart-drawer.active') || $('.menu-opening')) return;
      pop.hidden = false;
      raf(function () { raf(function () { pop.classList.add('is-open'); }); });
      var input = $('input[type="email"]', pop);
      if (input && window.matchMedia('(min-width: 750px)').matches) setTimeout(function () { input.focus({ preventScroll: true }); }, 400);
      store(3);
    }
    function close() {
      pop.classList.remove('is-open');
      setTimeout(function () { pop.hidden = true; }, 500);
      store(pop.classList.contains('is-success') ? 365 : 10);
    }
    $$('[data-hma-pop-close]', pop).forEach(function (b) { b.addEventListener('click', close); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('is-open')) close(); });
    var copy = $('[data-hma-copy]', pop);
    if (copy) copy.addEventListener('click', function () {
      var code = $('[data-hma-code]', pop).textContent.trim();
      (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).catch(function () {}).then(function () { copy.textContent = copy.dataset.copied; });
    });
    if (pop.classList.contains('is-open')) { store(365); return; }        // retour après inscription : déjà ouverte
    if (blocked() || (window.Shopify && Shopify.designMode)) return;
    var timer = setTimeout(open, 9000);
    var onScroll = function () {
      var h = doc.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h > 0.45) { clearTimeout(timer); window.removeEventListener('scroll', onScroll); open(); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    doc.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 8) { clearTimeout(timer); open(); } });
  }

  /* ---------- 7. Signature du pied de page ---------- */
  function setupWordmark() {
    var wm = $('.hma-wordmark');
    if (!wm || wm.dataset.hmaSplit) return;
    var text = wm.textContent.trim();
    wm.setAttribute('aria-label', text);
    wm.textContent = '';
    var inner = doc.createElement('span');
    inner.className = 'hma-wordmark__inner';
    inner.setAttribute('aria-hidden', 'true');
    text.split('').forEach(function (ch, i) {
      var l = doc.createElement('span');
      l.className = 'hma-wordmark__l' + (ch === ' ' ? ' hma-wordmark__l--space' : '');
      l.textContent = ch === ' ' ? ' ' : ch;
      l.style.setProperty('--i', i);
      inner.appendChild(l);
    });
    wm.appendChild(inner);
    wm.dataset.hmaSplit = '1';
    // ajuste la taille pour remplir exactement la largeur
    function fit() {
      wm.style.fontSize = '';
      var avail = wm.clientWidth - parseFloat(getComputedStyle(wm).paddingLeft) * 2;
      var natural = inner.scrollWidth;
      if (natural > 0) {
        var size = parseFloat(getComputedStyle(wm).fontSize) * (avail / natural);
        wm.style.fontSize = Math.max(32, Math.floor(size)) + 'px';
      }
    }
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(fit); else fit();
    window.addEventListener('resize', fit, { passive: true });
    if (reduceMotion || !('IntersectionObserver' in window)) { wm.classList.add('is-in'); return; }
    var io = new IntersectionObserver(function (e) {
      if (e[0].isIntersecting) { wm.classList.add('is-in'); io.disconnect(); }
    }, { threshold: 0.01 });
    io.observe(wm);
  }

  /* ---------- 8. Apparitions au scroll (éléments hors Dawn) ---------- */
  function setupReveals(root) {
    var items = $$('.hma-reveal:not(.hma-in), .hma-clip:not(.hma-in)', root);
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('hma-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('hma-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 9. Petites finitions ---------- */
  function polish() {
    // le bandeau de réassurance apparaît en douceur
    $$('.hma-usp__item').forEach(function (el, i) { el.classList.add('hma-reveal'); el.style.setProperty('--d', (i * 0.06) + 's'); });
    // ouvre le tiroir panier au-dessus de tout, et bloque le scroll de la page proprement
    var drawer = $('cart-drawer');
    if (drawer) {
      new MutationObserver(function () {
        doc.documentElement.classList.toggle('hma-lock', drawer.classList.contains('active'));
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function init() {
    buildMarquee();
    setupHeader();
    setupHero();
    setupStack();
    setupCartLabel();
    setupDescription();
    setupProduct();
    setupWordmark();
    setupUpsell();
    setupInfoSpacing();
    setupPopup();
    polish();
    setupReveals();
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();

  // Éditeur de thème
  doc.addEventListener('shopify:section:load', function (e) {
    buildMarquee(); setupHero(); setupStack(); setupWordmark(); setupReveals(e.target);
  });
})();
